export default __webpack_public_path__ + "static/fonts/Everett-Regular.ca4b695.woff";